import { useEffect } from 'react'
import { Chip, Modal } from '@enterprise-ui/canvas-ui-react'

export const FilterPopup = (props) => {
  const {
    headingText,
    onRemove,
    onRefuse,
    fieldConstant,
    removeChip,
    values,
    ...modalProps
  } = props

  useEffect(() => {
    if (!values?.length) {
      onRefuse()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values])

  const sortBy = (field) => {
    return function (a, b) {
      return (a[field] > b[field]) - (a[field] < b[field])
    }
  }

  const displayHeading = () => {
    if (headingText) {
      return headingText
    } else if (values?.length > 1) {
      return `${values?.length} ${fieldConstant?.pluralLabel}`
    } else {
      return `${values?.length} ${fieldConstant?.label}`
    }
  }

  return (
    <>
      {values?.length !== 0 ? (
        <Modal
          {...modalProps}
          className="hesp-filterPopup"
          size="dense"
          headingText={`${displayHeading()}`}
          onRefuse={onRefuse}
        >
          <div className="hesp-filterPopup-container">
            {values?.sort(sortBy('value')).map((item, index) => {
              if (removeChip) {
                return (
                  <Chip
                    className="hesp-filterPopup-chip hesp-filterPopup-button"
                    data-testid={'popup-chip-' + index}
                    removable
                    onRequestDelete={() => {
                      onRemove(item, fieldConstant.variableName, values, false)
                    }}
                    key={item.value + '-' + index}
                  >
                    {item}
                  </Chip>
                )
              } else {
                return (
                  <Chip
                    className="hesp-filterPopup-chip hesp-filterPopup-button"
                    data-testid={'popup-chip-' + index}
                    key={item.value + '-' + index}
                  >
                    {item}
                  </Chip>
                )
              }
            })}
          </div>
        </Modal>
      ) : (
        <></>
      )}
    </>
  )
}
